import React from "react";
// import image from "../public/Images/pageNotFound.svg"

const ErrorPage = () => {
  return (
    <div className="w-full h-[calc(100vh-75px)] absolute top-[75px] flex flex-col gap-5 items-center justify-center">
      <img
        src="/Images/pageNotFound.svg"
        alt=""
        className="h-[15rem] object-contain"
      />
      <h2 className="font-normal text-xl">Page Not Found! </h2>
    </div>
  );
};

export default ErrorPage;
